const styles = theme => ({
  buttonContainer: {
    textAlign: "right"
  },
  button: {
    margin: 8
  }
});
export default styles;
